import { forwardRef } from 'react'
import styles from './styles.module.scss'

type Props = {
  text: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ text }, ref) => (
    <textarea ref={ref} className={styles.textarea} value={text} readOnly />
  )
)

export default Textarea
